(() => {
  document.querySelectorAll('.bep-hero-slider').forEach(initHeroSlider);
})();

function initHeroSlider(section) {
  const sliderComponent = section.querySelector('slider-component');
  const splideRoot = sliderComponent?.querySelector('[data-ref="main-slider"]');
  const tabs = [...section.querySelectorAll('.bep-hero-slider__tab')];
  const currentEl = section.querySelector('.bep-hero-slider__current');
  const progressFill = section.querySelector('.bep-hero-slider__progress-fill');
  const prevBtn = section.querySelector('.bep-hero-slider__nav-btn--prev');
  const nextBtn = section.querySelector('.bep-hero-slider__nav-btn--next');
  const autoplay = section.dataset.autoplay === 'true';
  const autoplaySpeed = (Number(section.dataset.autoplaySpeed) || 6) * 1000;

  section.style.setProperty('--bep-hero-autoplay-ms', `${autoplaySpeed}ms`);
  if (autoplay) section.classList.add('is-autoplay');

  const padIndex = (index, total) => {
    const value = index + 1;
    return total > 9 ? String(value) : String(value).padStart(2, '0');
  };

  const restartProgress = () => {
    if (!progressFill || !autoplay) return;
    progressFill.style.animation = 'none';
    progressFill.offsetHeight;
    progressFill.style.animation = '';
    section.classList.remove('is-progress-paused');
  };

  const setActiveTab = (index) => {
    tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });
  };

  const updateUi = (index, total) => {
    if (currentEl) currentEl.textContent = padIndex(index, total);
    setActiveTab(index);
    restartProgress();
  };

  const bindSplide = () => {
    const splide = splideRoot?.splide;
    if (!splide) {
      requestAnimationFrame(bindSplide);
      return;
    }

    const total = splide.length || tabs.length;
    updateUi(splide.index, total);

    splide.on('move', (newIndex) => {
      updateUi(newIndex, total);
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.slideIndex);
        if (Number.isNaN(index)) return;
        splide.go(index);
      });
    });

    prevBtn?.addEventListener('click', () => splide.go('<'));
    nextBtn?.addEventListener('click', () => splide.go('>'));

    section.addEventListener('mouseenter', () => section.classList.add('is-progress-paused'));
    section.addEventListener('mouseleave', () => section.classList.remove('is-progress-paused'));
    section.addEventListener('focusin', () => section.classList.add('is-progress-paused'));
    section.addEventListener('focusout', () => section.classList.remove('is-progress-paused'));
  };

  if (splideRoot) bindSplide();
}

(() => {
  const section = document.querySelector('.bep-hollis-ugc');
  if (!section) return;

  const cards = [...section.querySelectorAll('.bep-hollis-ugc-card')];
  const filters = [...section.querySelectorAll('.bep-hollis-ugc-filter')];
  const allBtn = section.querySelector('.bep-hollis-ugc-filter--all');

  const setActiveFilter = (active) => {
    filters.forEach((filter) => {
      const isActive = filter === active;
      filter.classList.toggle('bep-hollis-filter--active', isActive);
      const button = filter.querySelector('.button');
      if (!button) return;
      button.classList.toggle('button--primary', isActive);
      button.classList.toggle('button--secondary', !isActive);
    });
  };

  const applyFilter = (gamme) => {
    cards.forEach((card) => {
      const show = gamme === 'all' || card.classList.contains(`bep-hollis-ugc-card--${gamme}`);
      card.hidden = !show;
    });
  };

  filters.forEach((filter) => {
    const button = filter.querySelector('.button');
    if (!button) return;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      const gamme = [...filter.classList]
        .find((className) => className.startsWith('bep-hollis-ugc-filter--'))
        ?.replace('bep-hollis-ugc-filter--', '') || 'all';

      setActiveFilter(filter);
      applyFilter(gamme);
    });
  });

  if (allBtn) {
    setActiveFilter(allBtn);
    applyFilter('all');
  }

  section.querySelectorAll('.bep-hollis-ugc-media').forEach((media) => {
    const video = media.querySelector('video');
    if (!video) return;

    const muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'bep-hollis-ugc-mute';
    muteBtn.setAttribute('aria-label', 'Activer le son');
    muteBtn.setAttribute('aria-pressed', 'false');
    media.appendChild(muteBtn);

    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      media.classList.toggle('is-unmuted', !video.muted);
      muteBtn.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
      muteBtn.setAttribute('aria-pressed', String(!video.muted));
    });
  });

  const allProductsBtn = section.querySelector('.bep-hollis-filter-all .button');
  if (allProductsBtn && !allProductsBtn.getAttribute('href')) {
    allProductsBtn.setAttribute('href', '/collections/all');
  }
})();
